"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.suggestions.title': 'Miglioramento Prompt IA',
    'ai.suggestions.description': 'Seleziona uno o più suggerimenti da inserire nel tuo prompt per la revisione. Poi puoi modificare e inviare manualmente.',
    'ai.suggestions.apply': 'Applica Suggerimenti',
    'ai.suggestions.clarification': 'Chiarimento aggiuntivo',
    'ai.suggestions.clarification.label': 'Chiarimento aggiuntivo (opzionale)',
    'ai.suggestions.clarification.placeholder': 'Aggiungi requisiti specifici o contesto...',
    'ai.suggestions.context.prompt': 'Da input',
    'ai.suggestions.context.message': 'Ultimo messaggio',
};
